import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_75: FaireProductEntity = {
  token: "starter_collection_75",
  type: "product",
  name: "Trout with Red Chimichurri",
  brandName: "Fishwife",
  imageUrl:
    '"https://cdn.faire.com/fastly/c17f3132e9ee881c94c065cd5a91dfefa97655028ad31b60a921a2a29d991ef5.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=1370',
  priceDollars: 14,
  msrpDollars: 28,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
